import amplitude from 'amplitude-js'

export default class Amplitude {

    constructor() {
        amplitude.getInstance().init(process.env.MIX_AMPLITUDE_API_KEY)
    }
    
    setUserId(userId) {
        amplitude.getInstance().setUserId(userId)
    }

    clearUserId() {
        amplitude.getInstance().setUserId(null)
    }

    log(event, properties = {}) {
        amplitude.getInstance().logEvent(event, properties)
        return true   // Used to avoid disabling href properties when assigning to <a> tag's onclick
    }

}